import { withStyles } from '@material-ui/core';
import styles from './Widget.styles';
import Widget from './Widget';

export default withStyles(styles)(Widget);
